import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useFreebetsTable } from '@Modal/hooks/freebets/useFreebetsTable';
import { useCreateFreebets } from '@Modal/hooks/freebets/useCreateFreebets';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const FreebetsTitle: React.FC = () => {
  const { freebetTableFilters, handleClearFreebetTableFilters } = useFreebetsTable();
  const { handleOpenCreateFreebetsModal, handleRevokeFreebetsModal } = useCreateFreebets();
  const objectVals = Object.values(freebetTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);
  const { userPermissions, currentUser } = useAuthorization();
  const permissionToRevokeFreebets =
    userPermissions?.includes('CAN_REVOKE_FREEBETS_CAMPAIGNS') || currentUser?.isSuper;
  const permissionToCreateFreebets =
    userPermissions?.includes('CAN_MANAGE_FREEBETS') || currentUser?.isSuper;

  return (
    <AtLocator type="container" name="FreebetsTitle">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: '4px 0' }}
      >
        <Typography variant="h3">Freebets</Typography>
        <Stack direction="row" gap="4px">
          {permissionToCreateFreebets && (
            <Button variant="contained" size="large" onClick={handleOpenCreateFreebetsModal}>
              Create Freebets
            </Button>
          )}
          {permissionToRevokeFreebets && (
            <Button
              variant="contained"
              color="error"
              size="large"
              onClick={() => handleRevokeFreebetsModal(true)}
            >
              Revoke Freebets
            </Button>
          )}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={handleClearFreebetTableFilters}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
